var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestionMark = function SvgQuestionMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.197.525C5.428.525.734 5.22.734 10.988c0 5.77 4.694 10.463 10.463 10.463 5.77 0 10.463-4.694 10.463-10.463C21.66 5.22 16.966.525 11.197.525Zm0 17.003a1.308 1.308 0 1 1 0-2.616 1.308 1.308 0 0 1 0 2.616Zm3.222-7.615c-.627.746-1.776 1.398-2.207 2.056-.19.288-.235.61-.246.932a.326.326 0 0 1-.326.315h-.908a.326.326 0 0 1-.327-.327c.003-.444.04-.992.318-1.5.211-.386.582-.786 1.111-1.198 1.02-.806 1.468-1.236 1.491-2.07.023-.785-.637-1.424-1.422-1.45-.69-.022-1.372-.006-2.654.584a.33.33 0 0 1-.437-.152l-.388-.815a.333.333 0 0 1 .146-.438 6.967 6.967 0 0 1 3.17-.747c1.037 0 1.86.254 2.468.762.609.508.913 1.209.913 2.103 0 .752-.204 1.351-.703 1.945Z",
    fill: "#fff"
  })));
};
export default SvgQuestionMark;